import React,{useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import numberbeautify from '../../../utils/numberbeautify';
import money_rounding from '../../../utils/money_rounding';
import moment from 'moment/moment';

const Ledger_table = () => {
    const { initState } = useContext(GlobalContext);
    return (
      <div className="mt-6">
            {/* Category List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                  <h2 className="text-base font-semibold text-slate-800">کەشف حساب</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                      <tr className="bg-slate-50 border-b border-slate-100">
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          جۆری چالاکی
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          کڕیار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          ژمارە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          بەروار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                          بڕ
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                      {initState?.ledger.map((lis,index)=>(
                        <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {lis.action_type=="sell"?"فرۆشتن":lis.action_type=="loan_in"?"قەرزی گەڕاوە":lis.action_type=="loan_out"?"قەرزی دراوە":lis.action_type=="expense"?"خەرجی":"خەسار"} {lis.action_type=="sell"&&(lis.sell_invoice_type=="cash"?"(کاش)":"(قەرز)")}
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {
                                lis.action_type=="sell"?
                                  lis.sell_invoice_customer_name+" - "+lis.sell_invoice_customer_address:
                                lis.action_type=="loan_in"?
                                  lis.customer_name+" - "+lis.customer_address:
                                lis.action_type=="loan_out"?
                                  lis.company_name+" - "+lis.company_address:
                                  "-"
                              }
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {lis.ledger_id}
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {moment(lis.ledger_date).format("YYYY-MM-DD hh:mm A")}
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {numberbeautify(money_rounding(lis.total_amount))}{lis.action_type=="loan_out"?"":" $"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
            </table>
          </div>
        </div>
    )
}

export default Ledger_table